<template>
  <div class="flex items-center h-full">
    <vs-button
      color="primary"
      type="border"
      icon-pack="feather"
      icon="icon-send"
      class="mx-auto"
      @click="sendEmail"
    ></vs-button>
  </div>
</template>
<script>
import { sendInvitation } from '@/api/client'
export default {

  mounted () {
    
  },
  data () {
    return {
      
    }
  },
  methods: {
    async sendEmail(){
        try{
            const data = await sendInvitation(this.$store.getters.customerId,this.params.data.basic_details.client_users_id)
             this.$vs.notify({
                title: 'Success',
                text: data.data.message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'success'
            })
        }catch(e){
            this.$vs.notify({
                title: 'Success',
                text: e.data.message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'success'
            })
        }
    
}
  }
}
</script>
